async function updateCartLineItem(data, quantity, canRedirect, callback = null, checkoutToken = null) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify(data)
  })

  if (response.status != 200) {
    return;
  }

  const cartResponse = await response.json();
  const snackbar = document.getElementById("snackbar");
  updateCartCount(quantity);

  if (canRedirect) {
    const newUrl = checkoutToken != null
      ? `${window.location.protocol}//${window.location.host}/checkouts/cn/${checkoutToken}`
      : `${window.location.protocol}//${window.location.host}/cart`;
    window.location.href = newUrl;
  } else {
    const productTitle = cartResponse.product_title || cartResponse.items[0].product_title;
    if (snackbar) {
      snackbar.innerHTML = `Your ${productTitle} has been added to the cart!`;
      snackbar.classList.add("show");

      setTimeout(() => { snackbar.classList.remove("show"); }, 3000);
    }
  }

  if (callback != null) {
    await callback(cartResponse.items_added[0].view_key)
  }

  return cartResponse.items_added[0].view_key;
}

async function isItemPresentInCart(items, variantId, properties) {
  const newComparableProperties = {
    ...properties,
    _additional_info: undefined,
    'Virtual consultation': undefined,
    _linked_items: undefined,
    _additional_charges: undefined
  }

  const newComparableItem = JSON.stringify({
    variant_id: parseInt(variantId),
    properties: newComparableProperties
  })

  return items.findIndex(item => {
    const comparableItem = JSON.stringify({
      variant_id: item.variant_id ?? item.id,
      properties: {
        ...item.properties,
        _additional_info: undefined,
        'Virtual consultation': undefined,
        _linked_items: undefined,
        _additional_charges: undefined
      }
    })

    return newComparableItem == comparableItem;
  });
}

function getArrayKeyValueCount(arr, key=undefined) {
  const keyCount = {};

  arr.forEach(info => {
    const value = key ? info[key] : info;

    if (keyCount[value] == undefined) keyCount[value] = 0;
    keyCount[value] += 1;
  })

  return keyCount;
}

export async function updatelinkedItemsProp(key, newLinkKeys) {
  const data = await fetch('/cart.js').then(res => res.json());
  const items = data.items;

  const itemIndex = items.findIndex(item => item.key == key);
  const linkedItemsProp = items[itemIndex]?.properties?._linked_items

  const linkedItems = (typeof(linkedItemsProp) == 'string' ? JSON.parse(linkedItemsProp) : linkedItemsProp) ?? {};
  const newLinkKeysObj = getArrayKeyValueCount(newLinkKeys);
  Object.keys(newLinkKeysObj).forEach(key => linkedItems[key] ?? newLinkKeysObj[key]);

  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8'
    },
    body: JSON.stringify({
      line: itemIndex + 1,
      properties: {
        ...items[itemIndex].properties,
        _linked_items: linkedItems
      }
    })
  }).then(res => res.json());

  return response;
}

export async function addTocart(id, properties, quantity, canRedirect, callback = null, redirectToCheckout = false, posthogCustomProps = {}) {
  const data = await fetch('/cart.js').then(res => res.json());
  const checkoutToken = data.token;

  if (handleize(posthogCustomProps?.initiator ?? "") == "cart-quick-shop") {
    properties._is_cart_quick_shop = true;
  }

  const items = data.items;

  if (properties['Color']) {
    productAddToCartAnalytics(properties['Color'], id, posthogCustomProps)
  }

  const itemIndex = await isItemPresentInCart(items, id, properties);

  if (itemIndex != -1) {
    const item = items[itemIndex];

    const linkedItems = (typeof(item.properties?._linked_items) == 'string' ? JSON.parse(item.properties?._linked_items) : item.properties?._linked_items) ?? {};
    const newLinkKeysObj = getArrayKeyValueCount(properties._linked_items ?? []);
    Object.keys(newLinkKeysObj).forEach(key => {
      linkedItems[key] = linkedItems[key] ?? newLinkKeysObj[key]
    });

    return await updateCartLineItem({
      'line': itemIndex + 1,
      'quantity': item.quantity + parseInt(quantity),
      'properties': {
        ...item.properties,
        _linked_items: linkedItems // [...new Set([...(item.properties._linked_items ?? []), ...(properties._linked_items ?? [])])]
      }
    }, quantity, canRedirect, callback, checkoutToken);
  } else {
    return await Shopify.addItem(quantity, id, {
      ...properties,
      _linked_items: getArrayKeyValueCount(properties._linked_items ?? [])
    }, canRedirect, callback, checkoutToken);
  }
}

export async function addItemsToCart(newItems, canRedirect, callback = null, redirectToCheckout = false, posthogCustomProps = {}) {
  const data = await fetch('/cart.js').then(res => res.json());
  const checkoutToken = data.token;

  if (handleize(posthogCustomProps?.initiator ?? "") == "cart-quick-shop") {
    newItems.forEach(item => item._is_cart_quick_shop = true);
  }

  const newItemsToAdd = data.items.reverse().map(item => ({
    id: item.variant_id,
    properties: item.properties,
    quantity: item.quantity
  })) ?? [];

  for (const item of newItems) {
    const { id, properties, quantity } = item;

    if (properties.Color) {
      productAddToCartAnalytics(properties['Color'], id, posthogCustomProps)
    }

    const itemIndex = await isItemPresentInCart(newItemsToAdd, id, properties);
    if (itemIndex == -1) {
      newItemsToAdd.push({
        ...item,
        properties: {
          ...properties,
          _linked_items: getArrayKeyValueCount(properties._linked_items ?? [])
        }
      })
    } else {
      const linkedItems = ( typeof(newItemsToAdd[itemIndex].properties?._linked_items) == 'string' ? JSON.parse(newItemsToAdd[itemIndex].properties?._linked_items) : newItemsToAdd[itemIndex].properties?._linked_items ) ?? {};
      const newLinkKeysObj = getArrayKeyValueCount(properties._linked_items ?? []);
      Object.keys(newLinkKeysObj).forEach(key => {
        linkedItems[key] = linkedItems[key] ?? newLinkKeysObj[key]
      });

      newItemsToAdd[itemIndex] = {
        ...newItemsToAdd[itemIndex],
        quantity: newItemsToAdd[itemIndex]?.quantity + parseInt(quantity),
        properties: {
          ...newItemsToAdd[itemIndex].properties,
          _linked_items: linkedItems
        }
      }
    }
  }

  await Shopify.clearCart();
  await Shopify.addItems(newItemsToAdd, canRedirect, callback, checkoutToken);
}
